import queryString from 'query-string';
import env from 'utils/env';
import isEmpty from 'lodash/isEmpty';
import request from './request';

export const getMetadataChoices = () => {
  const endpoint = `${env.aceApi}/1/admin/products/metadata`;
  return request(endpoint);
};

export const downloadProductsCSV = (isPublic, search) => {
  const queryParams = {};
  if (isPublic !== null) queryParams.isPublic = isPublic;
  if (search) queryParams.search = search.split(',');
  const endpoint = isEmpty(queryParams)
    ? '1/admin/products/csv'
    : `1/admin/products/csv?${queryString.stringify(queryParams, {
        arrayFormat: 'comma',
      })}`;
  return `${env.aceApi}/${endpoint}`;
};

export const createProduct = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products`;
  const data = JSON.stringify(formData);
  return request(
    endpoint,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const getTaxonomies = () => {
  const endpoint = `${env.aceApi}/1/admin/taxonomies`;
  return request(endpoint);
};

export const getProductById = (legacyPostId) => {
  const endpoint = `${env.aceApi}/1/admin/products/${legacyPostId}`;
  return request(endpoint);
};

export const updateProduct = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products`;
  const data = JSON.stringify(formData);
  return request(endpoint, 'PUT', { 'Content-Type': 'application/json' }, data);
};

export const getProductsCatalog = (limit, offset, isPublic, search) => {
  const queryParams = {};
  if (limit) {
    queryParams.limit = limit;
    queryParams.offset = offset;
  }
  if (isPublic !== null) queryParams.isPublic = isPublic;
  if (search) queryParams.search = search.split(',');
  const endpoint = isEmpty(queryParams)
    ? '1/admin/products'
    : `1/admin/products?${queryString.stringify(queryParams, {
        arrayFormat: 'comma',
      })}`;
  const requestUrl = `${env.aceApi}/${endpoint}`;
  return request(requestUrl);
};
